import React from "react";
import { useTranslation } from "react-i18next";
import { CopyField, Page, PageHeader } from "../../../components/ui";
import "./distribution.css";

/** RSS feeds of the podcasts, per content type (set in the environment). */
const feeds = () => [
  { id: "free", label: "Free Podcast RSS", value: process.env.REACT_APP_FREE },
  {
    id: "subscription",
    label: "Subscription Based Podcast RSS",
    value: process.env.REACT_APP_SUBSCRIPTION,
  },
  {
    id: "exclusive",
    label: "Exclusive Podcast RSS",
    value: process.env.REACT_APP_EXCLUSIVE,
  },
];

const PodcastDistribution = () => {
  const { t } = useTranslation();
  return (
    <Page>
      <PageHeader
        title={t("Podcast Distribution")}
        subtitle={t("Share these feeds with the podcast platforms (Spotify, Apple Podcasts…)")}
      />
      <section className="ui-card distribution-card">
        {feeds().map((feed) => (
          <CopyField
            key={feed.id}
            id={`rss-${feed.id}`}
            label={t(feed.label)}
            value={feed.value}
          />
        ))}
      </section>
    </Page>
  );
};

export default React.memo(PodcastDistribution);
